import React from "react";
import SupportPageLayout from "../Components/SupportPageLayout";
import SupportPageTitle from "../Components/SupportPageTitle";
import TermsAndConditions from "../Components/TermsAndConditions";

const Terms = () => {
  return (
    <SupportPageLayout>
      <SupportPageTitle text="Terms and Conditions" />
      <div>
        <TermsAndConditions />
      </div>
    </SupportPageLayout>
  );
};

export default Terms;
